import React, { useState } from "react";
import "./anchorCover.css";
import "../../index.css";

const AnchorCover = ({
  children,
  href,
  blank=null,
  class_Name = "",
  paddingClass
}) => {

  return (
    <a  href={href} target={blank ? "_blank" : "_self"} rel={blank ? "noopener noreferrer" : undefined} className={`anchor-cover ${class_Name && class_Name} ${class_Name && class_Name} ${paddingClass && paddingClass}`}>
        {children}
    </a>
  );  
};

export default AnchorCover;